import { render, staticRenderFns } from "./foodslist.vue?vue&type=template&id=3dff35db&scoped=true"
import script from "./foodslist.vue?vue&type=script&lang=js"
export * from "./foodslist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dff35db",
  null
  
)

export default component.exports